import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'

ClosureSurvey.ProgressBar = React.createClass({

  calculateWidth: function() {

    let stepIndex = this.props.steps.indexOf(this.props.currentStep)
    let numberOfSteps = this.props.steps.length - 1

    return ((stepIndex / numberOfSteps) * 100) + '%'
  },

  render: function() {
    return(
      <div className="row pt24 pl32 pr24">
        <div className="col-xs-10 col-sm-11 pr8 sm-pr16">
          <div className="progress m0 text-align-center radius-6" width="100%">
            <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="0" className="progress-bar" role="progressbar" style={{width: this.calculateWidth()}}>
              <span className="sr-only">Step 1 of 2</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
})
